import React, { useEffect } from 'react';

import {
    DeprecationWarning,
    FACEBOOK_DEPRECATION_PAGE,
    DeprecationWarningProps,
    Customer,
    deleteDeprecationModalCookie,
} from '@pegasus/deprecation-overlays';
import { useCustomer } from '@client/hooks';
import { useConfig } from '@browsing/config';

import { getIsLoggedIn } from '@client/redux/modules/customer/selectors';
import { getDeprecationExperiment, getVariantDetails } from '@shared/abtests/facebookDeprecation';
import { useSelector } from 'react-redux';
import { TRACK_DATA } from '@client/config/constants';
import { loadTrackData } from '@client/views/common/routingHelpers';
import { track } from '@client/helpers/tracking';
import { getCookie } from '@client/helpers/cookie';
import { isClient } from '@client/helpers/browser';

const isUserInFacebookDeepLinkPage = () =>
    window.location.href.includes(`/${FACEBOOK_DEPRECATION_PAGE}`);

interface propsWithOutAppDomain extends Omit<DeprecationWarningProps, 'localeCode'> {
    closable?: boolean;
}

const DeprecationWarningOverlayComponent = (props: propsWithOutAppDomain) => {
    const customer = useCustomer();
    const config = useConfig();

    useEffect(() => {
        loadTrackData().then(data => {
            track(TRACK_DATA, data);
        });
    }, []);

    return (
        <DeprecationWarning
            localeCode={config.localeCode}
            customer={customer as unknown as Customer}
            config={{
                externalIds: {
                    // @ts-expect-error
                    facebook: config?.facebook?.loungeAppId,
                },
            }}
            {...props}
        />
    );
};

export const DeprecationWarningOverlay = (props: propsWithOutAppDomain) => {
    const config = useConfig();
    const isFbDeprecationFeatureEnabled =
        config.isEnabled('facebookDeprecationWarning') || getCookie('facebook_deprecation');
    const experiment = useSelector(getDeprecationExperiment);
    const isLoggedInSession = useSelector(getIsLoggedIn);
    const isDeepLinkPage = isUserInFacebookDeepLinkPage();

    if (!isLoggedInSession && isDeepLinkPage) {
        if (isClient()) {
            window.location.assign('/login');
        }
        return null;
    }

    if (isDeepLinkPage) {
        deleteDeprecationModalCookie();
    }

    const { isVariant, isModalClosable } = getVariantDetails(experiment);

    if (!isFbDeprecationFeatureEnabled || !isVariant) {
        return null;
    }

    return <DeprecationWarningOverlayComponent {...props} closable={isModalClosable} />;
};
